<template>
  <div class="settle-account-row">
    <div class="settle-account-table">
      <vxe-grid
        :key="timeStamp"
        v-if="tableStatus"
        border
        show-footer
        :footer-method="footerMethod"
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        :data="tableData"
        :toolbar="{}"
        @radio-change="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <template v-slot:buttons v-if="isCreate">
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新增</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="radio" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumn"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <el-checkbox v-if="item.editRender.name == 'additional'" v-model="row[item.field]" />
            <span v-else-if="item.editRender.name == 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</span>
            <span v-else-if="item.editRender.name == 'currencyCode'">{{
              currencyList?.find((item) => item.value == row['currencyCode'])?.label
            }}</span>
            <span v-else-if="item.editRender.name == 'originalPrice'">{{
              row['originalPrice'] != null && row['originalPrice'] != ''
                ? (row['originalPrice'] - 0).toFixed(4)
                : ''
            }}</span>

            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 计算说明 -->
            <el-input
              v-if="item.editRender.name == 'settlementDesc'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
              minlength="2"
              maxlength="20"
            ></el-input>
            <el-select
              v-if="item.editRender.name == 'select'"
              filterable
              v-model="row[item.field]"
              @change="(e) => handleChange(row, item.field)"
            >
              <el-option
                v-for="(i, index) in item.editRender.options"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-select
              v-if="item.editRender.name == 'spaceAssetName'"
              filterable
              v-model="row[item.field]"
              @change="(e) => handleChange(row, item.field)"
            >
              <el-option
                v-for="(i, index) in item.editRender.options"
                :key="index"
                :label="i.leaseSpaceName"
                :value="i.spaceId"
              ></el-option>
            </el-select>
            <!-- 附加 -->
            <el-checkbox v-if="item.editRender.name == 'additional'" v-model="row[item.field]" />
            <!-- 业务单据编号 -->
            <el-input
              v-if="item.editRender.name == 'businessDocNo'"
              v-model="row[item.field]"
              maxlength="30"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              maxlength="50"
              @input="() => handleChange(row, item.field)"
            ></el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
      <el-upload
        style="display: none"
        ref="siruiUpload"
        :data="importData"
        :action="uploadUrl"
        accept=".xls,.xlsx"
        :before-upload="uploadBefore"
        :on-success="uploadSuccess"
        :show-file-list="false"
        :with-credentials="true"
        :on-error="uploadError"
      >
        <el-button ref="importBtn"></el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'SettleAccountsRow',
    props: {
      baseFormData: {
        type: Object,
        require: true,
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
      contractCategory: {
        type: String,
        default: () => '',
      },
      // 当前明细表
      currentDetailData: {
        type: Object,
        default: () => {},
      },
      spaceList: {
        type: Array,
        default: () => [],
      },
      // 详情的时候获取后端数据反填上去
      linesData: {
        type: Array,
        default: () => [],
      },
      settleAccountsDetailMap: {
        type: Map,
        default: () => new Map(),
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        tableRules,
        currencyList: [],
        uploadData: {}, // 上传参数
        uploadUrl: '',
        importData: {}, // 导入参数
        action: '',
        isFetchTableData: false,
        deleteLineIds: [], //删除行的ids
        cotractSpaceList: [],
        contractCa: '', //合同类型
        timeStamp: 0,
      };
    },
    computed: {
      tableColumn() {
        return tableColumnList(this);
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      expenseType() {
        return this.dictListMap.property_settlement_cost;
      },
      tableStatus() {
        return ['detail', 'edit', 'create'].includes(this.$route.query.status) &&
          this.$route.query?.id
          ? this.linesData.length
          : true;
      },
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['domesticAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            return null;
          }),
        ];
      },
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          count += +item[field];
        });
        return count > 0 ? count.toFixed(2) : 0;
      },
      async validAllEvent(isAdd = false) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          isAdd ? this.$message.error('请完善结算行数据') : this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },
      //是否可以编辑
      activeRowMethod({ columnIndex, row }) {
        console.log('这一行的数据', columnIndex, row, '空间信息', this.cotractSpaceList);
        if (['create'].includes(this.$route.query?.status) && this.$route.query?.id) {
          if (row?.id) {
            if (columnIndex == 2 || columnIndex == 3 || columnIndex == 14) {
              return true;
            } else {
              return false;
            }
          } else {
            let currentSettleAccountDetailList = this.settleAccountsDetailMap.get(row._XID);
            if (currentSettleAccountDetailList && currentSettleAccountDetailList.length) {
              if (columnIndex == 2 || columnIndex == 3 || columnIndex == 14) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          }
        } else {
          let currentSettleAccountDetailList = this.settleAccountsDetailMap.get(row._XID);
          console.log(
            '是否科比那几',
            ['04', '02', '06', '07'].includes(this.baseFormData.settlementStatus)
          );
          if (currentSettleAccountDetailList && currentSettleAccountDetailList.length) {
            if (
              (columnIndex == 2 || columnIndex == 13) &&
              !['04', '02', '06', '07'].includes(this.baseFormData.settlementStatus)
            ) {
              return this.isCreate;
            } else {
              return false;
            }
          } else {
            return this.isCreate;
          }
        }
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      //选择合同移除所有行
      removeRowHandler() {
        let deleteIds = this.getTableData().map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineIds = this.deleteLineIds.concat(deleteIds);

        const $table = this.$refs.settleAccountsRef;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      // 新增行
      async newRowHandler() {
        //默认选中
        let checkLinesRefStatus = await this.validAllEvent(true);
        if (checkLinesRefStatus) {
          return;
        }
        const { currencyCode, currencyName, exchangeRate, contractNo, expenseType } =
          this.baseFormData;
        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }
        const rowData = { currencyCode, currencyName, exchangeRate, contractNo, expenseType };
        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          //默认选中
          this.selectActiveHandler(this.getTableData()[0]);
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        // //费用清单创建的不能删
        // if (['create'].includes(this.$route.query?.status) && this.$route.query?.id) {
        //   if (this.selectionList[0].id) {
        //     this.$message.error('该条由费用清单创建数据不能删除');
        //     return;
        //   }
        // }
        this.$confirm('将同时删除结算明细，确认删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            const xIDList = this.selectionList.map((item) => item._XID);
            let deleteIds = this.selectionList.map((item) => (item.id ? +item.id : null));
            deleteIds = deleteIds.filter((item) => item);
            this.deleteLineIds = this.deleteLineIds.concat(deleteIds);
            this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
            this.$emit('deleteTableHandler', xIDList, this.tableData);
            //删除选择行数组
            this.selectionList = [];
            this.$emit('selectionRowHandler', null);
          })
          .catch(() => {});
      },
      async selectActiveHandler(row) {
        const $table = this.$refs.settleAccountsRef;
        await $table.setRadioRow(this.getTableData()[0]);
        console.log(row, '选择行变行');
        this.selectionList = [row];
        // 选择行
        this.$emit('selectionRowHandler', row);
      },
      handleSelectionChange({ row }) {
        this.selectionList = [row];
        console.log(this.selectionList, 'this.selectionList');
        // 选择行
        this.$emit('selectionRowHandler', row);
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        // if (field === 'currencyName') {
        //   row['currencyCode']=row['currencyName'];
        //   row['currencyName'] = this.currencyList?.find(
        //     (item) => item.value == row['currencyCode']
        //   )?.label;
        // } else
        if (field === 'originalAmount') {
          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;
        } else if (field === 'originalPrice') {
          let _XID = row._XID;
          const lineDetails = this.settleAccountsDetailMap.get(_XID);
          if (!lineDetails?.length) {
            row['originalAmount'] =
              +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';
          }
          // console.log(lineDetails, 'lineDetails999999999');
        } else if (field === 'settlementQuantity') {
          let _XID = row._XID;
          const lineDetails = this.settleAccountsDetailMap.get(_XID);
          if (!lineDetails?.length) {
            row['originalAmount'] =
              +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';
          }
        } else if (field === 'unit') {
          row['unitName'] = this.basic_unit?.find((item) => item.value == row['unit'])?.label;
        } else if (field === 'expenseTypeName') {
          if (this.contractCa != '01') {
            let tableData = this.getTableData();
            if (tableData.length > 1) {
              tableData.shift();
              let index = tableData.findIndex((item) => item.expenseType == row['expenseTypeName']);
              if (index != -1) {
                this.$message.warning('结算行中已存在该类型，请重新选择！');
                row['expenseType'] = '';
                row['expenseTypeName'] = '';
                return;
              }
            }
          } else {
            if (row['spaceAssetName']) {
              let tableData = this.getTableData();
              if (tableData.length > 1) {
                tableData.shift();
                this.tableData.forEach((item) => {
                  if (item.spaceAssetId == row['spaceAssetId']) {
                    if (item.expenseType == row['expenseTypeName']) {
                      this.$message.warning(`结算行中已存在相同数据，请重新选择！`);
                      row['expenseType'] = '';
                      row['expenseTypeName'] = '';
                      return;
                    }
                  }
                });
              }
            }
          }
          row['expenseType'] = row['expenseTypeName'];
          row['expenseTypeName'] = this.expenseType?.find(
            (item) => item.value == row['expenseType']
          )?.label;
        } else if (field === 'spaceAssetName') {
          console.log('row[spaceAssetName]', row['spaceAssetName']);
          let tableData = this.getTableData();
          if (tableData.length > 1) {
            tableData.shift();
            this.tableData.forEach((item) => {
              if (item.expenseType == row['expenseType']) {
                console.log(
                  typeof row['spaceAssetName'],
                  row['spaceAssetName'],
                  typeof item.spaceAssetId,
                  item.spaceAssetId
                );
                if (item.spaceAssetId == row['spaceAssetName'] - 0) {
                  this.$message.warning(`结算行中已存在相同数据，请重新选择！`);
                  row['spaceAssetId'] = '';
                  row['spaceAssetNo'] = '';
                  row['spaceAssetName'] = '';
                  return;
                }
              }
            });
          }
          row['spaceAssetId'] = row['spaceAssetName'];
          row['spaceAssetName'] = this.cotractSpaceList?.find(
            (item) => item.spaceId == row['spaceAssetId']
          )?.leaseSpaceName;
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件

          const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
          console.log(currencyCode, currencyName, exchangeRate, '查看修改费率');
          const tableData = this.getTableData().map((item) => {
            return {
              ...item,
              currencyCode,
              currencyName,
              exchangeRate,
            };
          });
          this.tableData = tableData;
          this.$emit('closeEditTableHandler', tableData);
          //默认选中
          await $table.setRadioRow(this.getTableData()[0]);
          this.selectActiveHandler(this.getTableData()[0]);
          await $table.clearActived();
          // //删除选择行数组
          // this.selectionList = [];
          // this.$emit('selectionRowHandler', null);
        }
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      // 修改明细表中反填表格数据到表中
      fullTableData(val) {
        console.log(val, '修改明细反填');
        if (!val) return;
        console.log(this, '------>>');
        const tableData = this.getTableData();
        const {
          _XID,
          __deduction,
          domesticAmount,
          originalAmount,
          originalPrice,
          settlementQuantity,
          unit,
          unitName,
          originalAmountWithoutTax,
          originalTaxAmount,
          domesticAmountWithoutTax,
          domesticTaxAmount,
        } = val;
        if (__deduction) {
          console.log('11111');
          // 抵扣的时候，并且判重复
          const isExist = tableData.find((item) => item.__deduction == val.__deduction);
          if (!isExist) {
            this.tableData.push(val);
          }
        } else {
          this.tableData = tableData.map((item) => {
            if (item._XID == _XID) {
              return {
                ...item,
                domesticAmount,
                originalAmount,
                originalPrice,
                settlementQuantity,
                unit,
                unitName,
                originalAmountWithoutTax,
                originalTaxAmount,
                domesticAmountWithoutTax,
                domesticTaxAmount,
              };
            } else {
              return item;
            }
          });
        }

        // 处理结算明细数据变动更新表单
        this.$emit('closeEditTableHandler', this.tableData);
      },
      // 开始上传
      uploadBefore() {
        this.loading.startLoading();
      },
      // 上传成功
      uploadSuccess(response) {
        this.loading.endLoading();
        if (response.code === 0) {
          if (response.data.length < 1) {
            this.$message.error('不支持的文件内容');
            return;
          }
          this.$message.success('导入成功');
          this.$emit('importData', response.data);
        } else {
          this.$message.error(`${response.msg}`);
        }
      },
      // 上传错误
      uploadError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
      // 反填远程返回的数据
      fullFetchTableData(val) {
        // 只需要处理一次,采用查重数组或者定义一个变量方式处理
        if (!this.isFetchTableData) {
          this.$nextTick(async () => {
            if (val.length > 0) {
              val.forEach((item) => {
                item.additional = item.additional == 1 ? true : false;
              });
            }
            const $table = this.$refs.settleAccountsRef;
            $table?.insertAt(val, 0);
            this.tableData = this.getTableData();
            // this.tableData = val;
            this.isFetchTableData = true;
            // 处理反填的时候结算明细表
            this.$emit('closeEditTableHandler', this.getTableData(), true);
            //当第一个结算行有明细时默认显示
            if (val[0].lineDetails) {
              this.$emit('selectionRowHandler', this.getTableData()[0]);
              //默认选中
              await $table.setRadioRow(this.getTableData()[0]);
              this.selectActiveHandler(this.getTableData()[0]);
            }
          });
        }
      },
    },
    mounted() {
      this.getCurrencyList();

      // this.uploadUrl = baseUrl + '/' + RECEIVABLES_TRADE.IMPORT_SETTLE_ACCOUNT_API;
    },
    watch: {
      spaceList: {
        handler(val) {
          this.cotractSpaceList = val;
          this.timeStamp++;
        },
        // immediate: true,
        deep: true,
      },
      contractCategory: {
        handler(val) {
          this.contractCa = val;
          console.log('合同类型改变了', val);
          if (val == '01') {
            this.tableRules.spaceAssetName = [{ required: true, message: '必填字段' }];
          } else {
            this.tableRules.spaceAssetName = [];
          }
        },
        // immediate: true,
        deep: true,
      },
      currentDetailData: {
        handler(val) {
          this.fullTableData(val);
        },
        // immediate: true,
        deep: true,
      },
      linesData: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.fullFetchTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settle-account-row {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
